export default {
      id: "ic_logo_white-usage",
      viewBox: "0 0 68 22",
      url: "/" + "images/icons.3.109.2.svg#ic_logo_white-usage",
      toString: function () {
        return this.url;
      }
    }